import React from 'react'
import Colors from 'colors.json'
import { Form, Formik } from 'formik'
import { Controller } from 'react-hook-form'

import { useBanksThor } from './useBanksThor'
import { useBanks } from './useBanks'

import DatetimePickerInput from 'components/DatetimePickerInput'
import Input from 'components/Input'
import { InputMaskField } from 'components/InputMaskField'
import Button from 'components/Button'
import Dropdown from 'components/Dropdown'
import { AddMerchantBankAccountsFetchParamsSchemasYup } from 'schemas/merchantBankAccountsSchemas'
import { useAddMerchantBankAccounts } from './useAddBankAccounts'
import { DropDownItem } from 'types/components'

const MERCHANTBANKACCOUNTTYPEOPTIONS: DropDownItem[] = [{ label: 'Std Bank Account', value: '1' }]

import { useForm } from 'react-hook-form'

const Index: React.FC<{ onCloseModal: () => void }> = ({
  onCloseModal,
}): React.ReactElement => {
  // STATES
  const { isLoading, initialValues, handleSubmitAddMerchantBankAccounts } =
    useAddMerchantBankAccounts(onCloseModal)
  const { bankThorNames, bankAccountFormat } = useBanksThor()
  const {
    memberBanksIsLoading,
    onSearchBank,
  } = useBanks()

  const { control } = useForm()

  if (isLoading) return <></>

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={AddMerchantBankAccountsFetchParamsSchemasYup}
      onSubmit={handleSubmitAddMerchantBankAccounts}
    >
      {({ values, isSubmitting, setFieldValue, errors, touched }) => {
        return (
          <Form className="flex flex-col">
            <div>
              <div>
                <div className="mb-5">
                  <Dropdown
                    title="Account Types"
                    options={MERCHANTBANKACCOUNTTYPEOPTIONS}
                    className="w-full tracking-wider mb-4"
                    borderColor="#C4C4C4"
                    onSelect={(item) =>
                      setFieldValue('bankAccountTypeId', Number(item.value))
                    }
                  />
                  <Controller
                    name="bankAccountNumber"
                    control={control}
                    render={({ field }) => {
                      const mask =
                        bankAccountFormat[0] === "00-0000-0000000-00"
                          ? "99-9999-9999999-99"
                          : "99-9999-9999999-999"

                      return (
                        <>
                          <InputMaskField
                            {...field}
                            readOnly={memberBanksIsLoading}
                            mask={mask}
                            type="input"
                            name="bankAccountNumber"
                            label="Account Number"
                            containerClassName="flex flex-col flex-grow"
                            rounded
                            // error={errors.bankAccountNumber}
                            // onChange={(e) => {
                            //   field.onChange(e.target.value)
                            //   onSearchBank(e.target.value, bankThorNames)
                            // }}
                            value={values.bankAccountNumber}
                            onChange={(e) => setFieldValue('bankAccountNumber', e.target.value)}
                          />
                          <p className="tracking-wide text-xs text-gray-500 my-1">
                            * If the suffix consists of two digits, please add a zero at
                            front of it to maintain the standard format.
                          </p>
                        </>
                      )
                    }}
                  />
                </div>
                <Input
                  name="name"
                  label="Account Name"
                  containerClassName="w-full"
                  type="input"
                />
                {/* <Input
                  name="safetyCode"
                  label="Security Code"
                  containerClassName="w-full"
                  type="input"
                /> */}
              </div>
              <div className="flex gap-4 justify-between">
                <DatetimePickerInput
                  title={'Expiry Date'}
                  setFieldName="expiryDate"
                  setFieldValue={setFieldValue}
                  showTimeSelect={false}
                  scrollableYearDropdown={true}
                />
              </div>
            </div>
            <div className="flex gap-4 items-center">
              <Input
                name="payerPartyCode"
                label="Payer Party Code"
                containerClassName="w-full"
                type="input"
              />
              <Input
                name="payerPartyParticulars"
                label="Payer Party Particulars"
                containerClassName="w-full"
                type="input"
              />
            </div>
            <div className="flex gap-4 items-center">
              <Input
                name="payeePartyParticulars"
                label="Payee Party Particulars"
                containerClassName="w-full"
                type="input"
              />
              <Input
                name="payeePartyCode"
                label="Payee Party Code"
                containerClassName="w-full"
                type="input"
              />
            </div>
            <Input
              name="payeePartyRef"
              label="Payee Party Reference"
              containerClassName="w-full"
              type="input"
            />
            <div className="flex items-center mb-6">
              <label
                htmlFor="flEmail"
                className="text-gray-500 mr-2 font-light"
              >
                Make Default
              </label>
              <input
                type="checkbox"
                id="isDefaultBankAccount"
                name="isDefaultBankAccount"
                className="mr-2"
                onChange={(e) => {
                  setFieldValue(
                    'isDefaultBankAccount',
                    e.target.checked ? 1 : 0
                  )
                }}
              />
            </div>
            <footer className="flex justify-end pb-4 pl-4 pr-0">
              <Button
                type="submit"
                className="mr-2 rounded bg-primary"
                disabled={isSubmitting}
              >
                <span className="tracking-wider font-bold">Submit</span>
              </Button>
              <Button
                className="bg-white border rounded border-primary"
                onClick={onCloseModal}
                style={{ color: Colors.primary }}
              >
                <span className="tracking-wider font-bold">Cancel</span>
              </Button>
            </footer>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Index
